export default __webpack_public_path__ + "static/media/banner-2.1d6ee2df.jpg";